module.exports = __webpack_public_path__ + "img/header-heart.4f74ab20.png";